import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import arrowLeft from "../assets/images/arrow-left.png";
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import startWhite from "../assets/images/startWhite.png";
import startGold from "../assets/images/startGold.png";
import { getChildrenForAttendance, submitChildFeedback } from '../services/TeacherApi';
import LoadingSpinner from './LoadingSpinner';
import { showToast } from '../config/Alert';
import moment from 'moment';

const TeacherFeedback = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const location = useLocation();
  const { slot } = location.state || {};
  const [children, setChildren] = useState([]);
  const [selectedChildId, setSelectedChildId] = useState("");
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    comments: "",
    attendance_rating: 0,
    participation_rating: 0, skill_improvement_rating: 0,
    focus_discipline_rating: 0, creativity_rating: 0,
    milestone: "", next_month_goals: ""
  });
  const currentDateTime = moment().format("DD MMM, YYYY hh:mm A");

  useEffect(() => {
    const fetchChildren = async () => {
      try {
        const response = await getChildrenForAttendance({
          time_slot_id: slot.time_slot_id,
          focus_id: slot.focus_id,
          day: slot.day,
          start_time: slot.start_time,
          end_time: slot.end_time,
          teacher_id: user.user_data.id,
        });
        setChildren(response.data.children);
      } catch (error) {
        console.error("Failed to fetch children for attendance", error);
      } finally {
        setLoading(false);
      }
    };

    if (slot) {
      fetchChildren();
    }
  }, [slot]);

  const handleStarClick = (field, rating) => {
    setFormData({ ...formData, [field]: rating });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        teacher_id: user.user_data.id,
        child_id: selectedChildId,
        program_id: slot.program_id,
        skill_level_id: slot.skill_level_id,
        time_slot_id: slot.time_slot_id,
        focus_id: slot.focus_id,
        ...formData
      };
      await submitChildFeedback(payload);
      setLoading(false);
      showToast("Feedback submitted successfully!", "success");
      navigate('/teacherDashboard');
    } catch (err) {
      console.error("Error submitting feedback:", err);
      showToast("Failed to submit feedback", "error");
    }
  };

  const renderStars = (field, rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Button
        key={i}
        type="button"
        variant="unknown"
        className="p-0"
        onClick={() => handleStarClick(field, i + 1)}
      >
        <img src={i < rating ? startGold : startWhite} alt="star" />
      </Button>
    ));
  };

  const bgColors = [
    "bg_dark_green",
    "bg_dark_purple",
    "blue3",
    "bg_dark_blue",
    "bg_dark_yellow"
  ];

  const ratingDescriptions = {
    attendance_rating: "Great attendance, but missed a couple of classes.",
    participation_rating: "Moderate participation, can contribute more.",
    skill_improvement_rating: "Excellent progress, skills are improving rapidly.",
    focus_discipline_rating: "Good focus overall, but occasional distraction.",
    creativity_rating: "Highly creative and expressive, stands out in class."
  };


  if (loading) return <LoadingSpinner />;

  return (
    <div className='app-container mobile-bottom'>
      <Container>

        <div className='breadcrum bg_light_yellow'>
          <h2 className='d-flex align-items-center mb-0 fs-20'>
            <Link to={`/attendanceTeacher/${slot.program_id}`} state={{ skillLevelId: slot.skill_level_id }}><img src={arrowLeft} width={18} className='me-2' alt="link" /></Link>
            Feedback</h2>
        </div>
        <div className="mt-3">
          <div className="d-flex justify-content-between">
            <h2 className='fs-20 fw-6 mb-1'>
              <span className='small-hello fs-14'>Hello, </span>
              <span className='bigg-name'>{user?.name}!</span>
              <p>
                <span className="fs-10 fw-normal">{slot?.program_name} {slot?.focus && (`- ${slot?.focus?.title}`)} - {slot?.skill_level_name} Class</span>
                <span className="d-block fs-10  fw-normal">{slot?.start_time} - {slot?.end_time} | {slot?.day_name}</span>
              </p>
            </h2>
            <div>
              <p className="fs-13 fw-6">{currentDateTime}</p>
            </div>
          </div>
          <p className="mb-1 ps-2">Enter Feedback</p>
          <div className='attendance mb-4 p-4 rounded-4'>
            <Row>
              <Col xs='12'>
                <Form.Select
                  aria-label="Select Child"
                  className='bg-danger text-white mb-3 fs-12'
                  value={selectedChildId}
                  onChange={(e) => setSelectedChildId(e.target.value)}
                >
                  <option value="">Select Child</option>
                  {children.map(child => (
                    <option key={child.id} value={child.id}>{child.name}</option>
                  ))}
                </Form.Select>
              </Col>
            </Row>

            <div className="bg-white py-2 px-4 rounded-4">
              <h5 className='text-danger fw-6 fs-14'>Teachers Comments</h5>
              <Form.Control
                as='textarea'
                rows={3}
                value={formData.comments}
                onChange={(e) => setFormData({ ...formData, comments: e.target.value })}
              />
              <div className='border-2 my-4 border-bottom'></div>

              <Row className='my-2 justify-content-center'>
                {["attendance_rating", "participation_rating", "skill_improvement_rating", "focus_discipline_rating", "creativity_rating"].map((field, idx) => (
                  <Col xs='6' key={field}>
                    <div className='ratingSection mb-3'>
                      <h6 className='text-danger fs-14 fw-6'>
                        {field.replace(/_/g, ' ').replace("focus discipline", "Focus & Discipline").replace("rating", "").trim().replace(/\b\w/g, l => l.toUpperCase())}
                      </h6>
                      <div className={`startSection rounded-1 ${bgColors[idx]} p-2 d-flex justify-content-between`}>
                        {renderStars(field, formData[field])}
                      </div>
                      <small className='fs-9 fw-5'>{ratingDescriptions[field]}</small>
                    </div>
                  </Col>
                ))}
              </Row>
              <div className='border-2 my-4 border-bottom'></div>
              <Row className=''>
                <Col xs='6'>
                  <h6 className='text-danger fs-14 fw-6'>This Month's Milestones</h6>
                  <Form.Control
                    as='textarea'
                    rows={2}
                    value={formData.milestone}
                    onChange={(e) => setFormData({ ...formData, milestone: e.target.value })}
                  />
                </Col>
                <Col xs='6'>
                  <h6 className='text-danger fs-14 fw-6'>Goals for the Next Month</h6>
                  <Form.Control
                    as='textarea'
                    rows={2}
                    value={formData.next_month_goals}
                    onChange={(e) => setFormData({ ...formData, next_month_goals: e.target.value })}
                  />
                </Col>
              </Row>
            </div>
            <div className="text-center py-3">
              <Button type="submit" className="rounded-4" variant="danger" onClick={handleSubmit}>Submit for Approval</Button>
            </div>

          </div>
        </div>
      </Container>
    </div>
  );
}

export default TeacherFeedback;